<template>
  <div class="section-div-wrapper">
      <div class="section-title-wrapper">
          <div class="dot"></div>
          <h3>
              <span class="section-title-ja">{{ titleJa }}</span>
              <span class="section-title">{{ titleEn }}</span>
          </h3>
      </div>
      <div class="section-desc-wrapper">
          <p>{{ description }}</p>
      </div>
  </div>
</template>

<script>
export default {
  name: "SectionTop",
  inject: ["menuItems"], // App.vueのprovideからmenuItemsを取得
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    // セクションに応じたタイトルを取得
    sectionData() {
      return this.menuItems.find((item) => item.id === this.id);
    },
    titleJa() {
      return this.sectionData?.ja || "デフォルト日本語タイトル";
    },
    titleEn() {
      return this.sectionData?.name || "Default Title";
    },
    description() {
      return this.sectionData?.description || "デフォルトの説明文";
    },
  },
};
</script>

<style scoped>
.section-div-wrapper {
  top: 0;
  left: 10%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start; 
  gap: 30px;
}
.section-div-wrapper span {
  font-family: sans-serif;
  color: #1b1b1b;
  margin-right: 1.5em;
}
.section-title-wrapper {
  display: flex;
  flex-direction:row;
  align-items: center;
  gap: 2.5em;
  height: auto;
}
.dot {
  width: 40px;
  height: 40px;
  border-radius:50%;
  background: #003633;
}
.section-title-ja {
  font-size: 25px;
}
.section-title {
  font-size: 18px;
}
.section-desc-wrapper{
  display: flex;
  flex-direction: column; 
  left: 100px;
}
.section-desc-wrapper p {
  font-family: sans-serif;
  font-size: 15px;
  line-height: 2rem;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .dot {
    width: 23px;
    height: 23px;
  }

  .section-title-ja {
    font-size: 15px;
  }

  .section-title {
    font-size: 12px;
  }

  .section-desc-wrapper p {
    font-size: 12px;
  }

}

@media screen and (max-width: 570px) {
  .section-div-wrapper {
    gap: 5px;
  }

  .dot {
    width: 23px;
    height: 23px;
  }

  .section-title-ja {
    font-size: 15px;
  }

  .section-title {
    font-size: 12px;
  }

  .section-desc-wrapper p {
    font-size: 12px;
  }

}
</style>